import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField, Autocomplete } from '@mui/material';

type Option = {
    value: string | number;
    label: string;
};

interface IProps {
    name: string;
    options: Option[] | any[];
    fullWidth?: boolean;
    multiple?: boolean;
    freeSolo?: boolean;
    getOptionLabel?: (option: any) => string;
    disabled?: boolean;
    isOptionEqualToValue?: (option: any, value: any) => boolean;
}

type Props = IProps & Omit<React.ComponentProps<typeof TextField>, 'onChange' | 'value'>;

export default function RHFAutoComplete({
    name,
    options,
    fullWidth,
    multiple,
    freeSolo,
    getOptionLabel,
    disabled,
    isOptionEqualToValue,
    ...other
}: Props) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <Autocomplete
                    isOptionEqualToValue={isOptionEqualToValue ?? undefined}
                    disabled={disabled}
                    options={options}
                    getOptionLabel={getOptionLabel || ((option) => option.label)}
                    value={field.value || (multiple ? [] : null)}
                    onChange={(_, newValue) => field.onChange(newValue || (multiple ? [] : null))}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            fullWidth={fullWidth}
                            error={!!error}
                            helperText={error?.message}
                            {...other}
                        />
                    )}
                    multiple={multiple}
                    fullWidth={fullWidth}
                    freeSolo={freeSolo}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '9999px',
                        }
                    }}
                />
            )}
        />
    );
}
